export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-4.37a2b0cf.png";